export default __webpack_public_path__ + "static/dekstop-67bf13c181b3f96a081d933770c3ac25.png";